import { render, staticRenderFns } from "./PI1.vue?vue&type=template&id=e97c3b06&scoped=true&"
import script from "./PI1.vue?vue&type=script&lang=js&"
export * from "./PI1.vue?vue&type=script&lang=js&"
import style0 from "./PI1.vue?vue&type=style&index=0&id=e97c3b06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97c3b06",
  null
  
)

export default component.exports